// Shared design tokens for the 2F redesign. Import these instead of
// redeclaring per-file constants — EventCard, CalendarPage, HomePage,
// HighlightsPage and EventGroupCard must all stay on the same palette.

export const ORANGE = '#FFA500';
export const ORANGE_DARK = '#F29400';
export const ORANGE_BG = '#FFF6E8';
export const LINE = '#EEE7DC';
export const INK = '#212121';
export const MUTED = '#757575';

// Chip palettes for event status/type badges
export const GREEN = '#2e7d32';
export const GREEN_BG = '#e8f5e9';
export const RED = '#c62828';
export const RED_BG = '#ffebee';
export const BLUE = '#1565c0';
export const BLUE_BG = '#e3f2fd';

export const FALLBACK_EVENT_IMAGE = '/images/placeholder-event.jpg';

// Card shell shared by every event surface
export const CARD_SHADOW = '0 2px 4px rgba(0,0,0,0.08)';
export const CARD_HOVER_SHADOW = '0 8px 24px rgba(255,165,0,0.35)';
